// src/components/DesignSpecifications.js

import React from "react";

const formatFieldLabel = (field) => {
  if (!field) return "";
  const words = field.replace(/([A-Z])/g, " $1").split(" ");
  return words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

const findLabelForValue = (field, value, options) => {
  const fieldOptions = options[field] || [];
  const option = fieldOptions.find((opt) => opt.value === value);
  return option ? option.label : formatFieldLabel(value);
};

// Accept the new 'loading' prop
const DesignSpecifications = ({
  specs,
  measurements,
  options,
  dynamicDressName,
  onOrderNow,
  onFinalAddToCart,
  loading,
  generatedImage,
}) => {
  const hasMeasurements = !!measurements?.waist;

  const measurementSpecs = {
    "Sleeves Length": specs?.sleevesLength,
    "Shoulder Width": specs?.shoulderWidth,
    "Chest Around": specs?.chestAround,
    Waist: specs?.waist,
    Stomach: specs?.stomach,
    Hips: specs?.hips,
  };

  return (
    <div className="w-full h-full flex flex-col items-center text-center p-6 bg-white/90 backdrop-blur-lg rounded-2xl shadow-2xl">
      <div className="flex-shrink-0">
        <h2 className="text-2xl font-bold text-gray-800 tracking-wide uppercase">
          {dynamicDressName}
        </h2>
        <p className="text-sm text-gray-500 mt-1 uppercase tracking-wider">
          {`${findLabelForValue(
            "sleeve",
            specs?.sleeve,
            options
          )} ${findLabelForValue("neckline", specs?.neckline, options)}`.trim()}
        </p>
        <p className="text-4xl font-light text-gray-800 my-4">$180.00</p>
      </div>

      <div className="w-full border-t border-gray-200 my-4"></div>

      <div className="w-full overflow-y-auto custom-scrollbar flex-grow mb-4">
        {/* Only show the full spec list if measurements HAVE NOT been saved yet */}
        {!!generatedImage && (
          <ul className="space-y-2 text-sm text-gray-700 pr-2">
            {Object.entries(specs).map(([field, value]) =>
              value && field !== "_DesignPreview" ? (
                <li
                  key={field}
                  className="flex justify-between items-center border-b border-gray-200 py-2"
                >
                  <span className="font-medium text-gray-500">
                    {formatFieldLabel(field)}:
                  </span>
                  <span className="font-semibold text-right">
                    {findLabelForValue(field, value, options)}
                  </span>
                </li>
              ) : null
            )}
          </ul>
        )}
        {/* Show the saved measurements list if they exist */}
        {hasMeasurements && (
          <div className="w-full text-left">
            <h3 className="text-lg font-semibold text-green-600 mb-2 flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 mr-2"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clipRule="evenodd"
                />
              </svg>
              Measurements Saved
            </h3>
            <ul className="space-y-2 text-sm text-gray-700 pl-2 pr-2 border-l-2 border-green-200">
              {Object.entries(measurementSpecs).map(([label, value]) =>
                value ? (
                  <li key={label} className="flex justify-between">
                    <span className="font-medium text-gray-500">{label}:</span>
                    <span className="font-semibold">{value} cm</span>
                  </li>
                ) : null
              )}
            </ul>
          </div>
        )}
      </div>

      <div className="w-full mt-auto flex-shrink-0 pt-4">
        {hasMeasurements && generatedImage ? (
          // --- UPDATED BUTTON with loading state ---
          <button
            onClick={onFinalAddToCart}
            disabled={loading} // Disable button when loading
            className="w-full max-w-xs bg-blue-600 text-white font-bold py-3 px-6 rounded-full transition-all duration-200 flex items-center justify-center hover:scale-105 disabled:opacity-75 disabled:scale-100"
          >
            {loading ? (
              <>
                <svg
                  className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                Processing...
              </>
            ) : (
              "Add to Cart & Checkout"
            )}
          </button>
        ) : (
          <button
            onClick={onOrderNow}
            className="w-full max-w-xs bg-pink-600 text-white font-bold py-3 px-6 rounded-full transition-transform duration-200 hover:scale-105"
          >
            Add Measurements
          </button>
        )}
        <p className="text-xs text-gray-500 mt-3">
          ORDER TODAY, RECEIVE IN 3 WEEKS
        </p>
      </div>
    </div>
  );
};

export default DesignSpecifications;
